import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
export interface ICareersInnerSidebarFormProps extends IBaseElementProps {
	/**
	 * Career Sidebar Form Component Children
	 */
	children?: any;
	isConfirmation?: boolean;
	logoTagline?: string;
}
import logo from '../../../assets/images/logo-colour.svg';

const CareersInnerSidebarForm: React.FC<ICareersInnerSidebarFormProps> = ({
	isConfirmation,
	logoTagline = 'Careers Centre',
	children
}) => {
	return <div className="d-flex flex-column justify-content-center align-items-center gap-5 gap-md-6">
		{isConfirmation && <div className="calian-careers-inner-sidebar-success-message__content--top">
			<i className="icon icon-success text-primary"></i>
		</div>}
		<div className="calian-careers-inner-sidebar-success-message__content--middle">
			{children}
		</div>
		{isConfirmation && <div className="calian-careers-inner-sidebar-success-message__content--bottom mt-8">
			<div className="d-flex flex-row justify-content-center align-items-center">
				<img src={logo} alt="" width="180" height="64" className="img-fluid me-0 me-md-2 me-lg-4"/>
				<p className="calian-careers-inner-sidebar-success-message__business-unit d-flex flex-row justify-content-center align-items-center mb-0 fs-18px fw-bold">{logoTagline}</p>
			</div>
		</div>}
	</div>
}

export default CareersInnerSidebarForm;
